import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setOptionEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageReservationsSection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    navigate(Paths.tourManagementPackageOptionsConnectivity, {
      state: { optionData },
    });
  };

  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Reservations</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content  */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Reservations</p>
              <p className="text-secondary capitalize">
                {optionData?.reservations === true ? "Yes" : "No"}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Reservation System</p>
              <p className="text-secondary capitalize">
                {optionData?.reservationSystem
                  ? optionData.reservationSystem
                  : "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="text-sm font-bold">External Product ID</p>
              <p className="text-secondary capitalize">
                {optionData?.externalProductId ?? "N/A"}
              </p>
            </div>
          </div>
          {/* <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Availability</p>
              <p className="text-secondary capitalize">
                {optionData?.availability === "operating_hours"
                  ? "Operating Hours"
                  : optionData?.availability === "fixed_time_slots"
                  ? "Fixed Time Slots"
                  : "N/A"}
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
